import { commonState } from '../../../../../../stores/common';
import { bingBankAcc, fourFactorVerify } from '../../../../../../api/open-account';
import { LastNextBtns } from '../../components/LastNextBtns';
import { changeFile, lastProcess, nextProcess, pState, setFormApi } from '../../store';
import { UploadBankCard } from '../../UploadBankCard';
import { Form, FormApi, reactive } from 'cdui-js';
import { OpenFormItem } from '../../components/OpenFormItem';
import { aesEncryptHexByPass } from '../../../../../../lib/crypto';
import { showToast } from '../../../../components/Toast';
import i18n from '../../../../../../i18n';
import { DiFiInput } from '../../../../../../components/DiFi/DiFiInput';

// 四要素认证
const fourAuth = async () => {
  // 四要素认证
  const four = await fourFactorVerify({
    idCardName: pState.uploadLicForm.fullName,
    idCardNumber: pState.uploadLicForm.idCardNo,
    unionpayCardnumber: pState.unionPayCard.bankAccountNo,
    phoneNumber: pState.unionPayCard.phone,
  });
  pState.fourOrderno = four.orderno;

  return four;
};

// UNION_PAY_AUTH

export const UploadBank = (props) => {
  let formApi: FormApi = null;

  const state = reactive({
    loading: false,
  });

  const bankImg = () => {
    const item = pState.attachmentList?.find((i) => i.busId === pState.id && i.attachType === 'bank_card');
    return item?.fileUrl || '';
  };

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="font-s-L font-bold color-D margin-b-XS">
        {i18n.OpenProgress.Info.UnionPay.Title}
        {props.stepText}
      </div>

      <UploadBankCard
        class="margin-t-L"
        img={bankImg()}
        busId={pState.id}
        change={({ url, data }) => {
          changeFile('bank_card', url);

          if (data?.ocrResult) {
            const r = data?.ocrResult;
            //   const dates = (data.ocrResult?.validPeriod || '').split('-');
            //   if (dates.length) {
            //     pState.uploadLicForm.idCardStartDate = dates[0];
            //     pState.uploadLicForm.idCardEndDate = dates[1];
            //   }
            pState.unionPayCard.bankAccountNo = r.cardNumber || '';
            pState.unionPayCard.bankName = r.bankName || '';

            //           bankName
            // :
            // "中国工商银行"
            // cardNumber
            // :
            // "5309999900008000"
            // cardType
            // :
            // "DC"
            // validToDate
            // :
            // "00/00"
          }
        }}
      />

      <div class="color-D margin-t">
        <div>{i18n.OpenProgress.Info.UnionPay.Guide1}</div>
        <div>{i18n.OpenProgress.Info.UnionPay.Guide2}</div>
        <div>{i18n.OpenProgress.Info.UnionPay.Guide3}</div>
        <div>{i18n.OpenProgress.Info.UnionPay.Guide4}</div>
      </div>

      <div class="margin-t">
        <div class="font-bold color-D margin-b font-s">{i18n.OpenProgress.Info.UnionPay.IdInfoSection}</div>

        <Form data={pState.unionPayCard} rules={{}} align="top" api={(api) => { formApi = api; setFormApi(api); }}>
          <OpenFormItem label={i18n.OpenProgress.Info.UnionPay.LabelBank} field="bankName" required>
            <DiFiInput
              shellClass="f-input-2"
              inputKind="text"
              maxLength={80}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
              value={pState.unionPayCard.bankName}
              onUpdateValue={(v) => (pState.unionPayCard.bankName = v)}
            />
          </OpenFormItem>

          <OpenFormItem label={i18n.OpenProgress.Info.UnionPay.LabelAccountNo} field="bankAccountNo" required>
            <DiFiInput
              shellClass="f-input-2"
              inputKind="bank-account"
              maxLength={50}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
              value={pState.unionPayCard.bankAccountNo}
              onUpdateValue={(v) => (pState.unionPayCard.bankAccountNo = v)}
            />
          </OpenFormItem>

          <OpenFormItem label={i18n.OpenProgress.Info.UnionPay.LabelPhone} field="phone" required>
            <DiFiInput
              shellClass="f-input-2"
              type="tel"
              inputKind="tel"
              maxLength={50}
              value={pState.unionPayCard.phone}
              placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
              onUpdateValue={(e) => (pState.unionPayCard.phone = e)}
            />
          </OpenFormItem>
        </Form>
      </div>

      <LastNextBtns
        loading={state.loading}
        last={() => {
          lastProcess();
        }}
        next={async () => {
          if (!bankImg()) {
            showToast(i18n.OpenProgress.Info.UnionPay.ToastCardRequired || '请上传银行卡');
            return;
          }

          const valid = await formApi.validate();
          if (!valid) {
            return;
          }

          try {
            state.loading = true;
            // const v = await fourAuth();

            // if (!v.success) {
            //   showToast(i18n.OpenProgress.Info.UnionPay.ToastInvalidCard);
            //   state.loading = false;
            //   return;
            // }

            const params = JSON.parse(JSON.stringify(pState.unionPayCard));
            console.log('[encryptKey][beforeEncrypt][unionPayCard]', {
              encryptKey: commonState.encryptKey || '(empty)',
              plainLen: String(params.bankAccountNo || '').length,
            });
            params.bankAccountNo = aesEncryptHexByPass(params.bankAccountNo, commonState.encryptKey);

            await bingBankAcc({
              ...params,
              process: 4,
            });

            nextProcess();
          } catch {
            state.loading = false;
          } finally {
            state.loading = false;
          }
        }}
      />
    </div>
  );
};
